import React from "react";

export default function Card({ children, className = "" }) {
  return (
    <div
      className={[
        "rounded-2xl",
        "border border-white/10",
        "bg-white/[0.03]",
        "shadow-[0_10px_30px_rgba(0,0,0,0.25)]",
        "transition-colors duration-200",
        className,
      ].join(" ")}
    >
      {children}
    </div>
  );
}
